const updatePalettesWith = (paletteToUpdate, palettes) => {
  const targetPaletteIndex = palettes.findIndex(({ id }) => id === paletteToUpdate.id);
  if (targetPaletteIndex >= 0) {
    const updatedPalettes = [...palettes];
    updatedPalettes[targetPaletteIndex] = paletteToUpdate;
    return updatedPalettes;
  }
  return [...palettes, paletteToUpdate];
};

export default updatePalettesWith;
